
// NATIVE 


// INSTALLED 

// CUSTOM 
import { AxiosAdapter } from "../commons/adapters";
import { closeSessionGlobal } from "../commons/utils";


const http = new AxiosAdapter();



export const markOneAsReadService = async(notificationId:string) => {
   
    try {

        return await http.patch<any>(`/v1/notifications-read/mark-read/${notificationId}`); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getEmployeesInShiftService ',error)
    }
}
